import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { gql } from '@apollo/client'
import { CALENDAR_ACTIVITY_REPORT_QUERY } from '../../../graphql.js'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { reverseDate } from '../../../utils'
import { csvUrl, getData, getInputParams, reportDate, sortColumnClicked } from '../CustomUtils'
import '../Custom.css'
import ColumnHeadings from '../ColumnHeadings.js'
import ResultsGrid from '../ResultsGrid.js'
import LargeRowHandler from '../LargeRowHandler.js'

const CALENDAR_ACTIVITY_REPORT = gql(CALENDAR_ACTIVITY_REPORT_QUERY)

export default function CalendarActivityReport({ location }) {
  console.log('Calendar Activity Report rendered:', location)

  const navigate = useNavigate()
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, CALENDAR_ACTIVITY_REPORT, 'calendarActivityReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const inputs = getInputParams(location)
    let date = reportDate()
    let dateFrom
    if (inputs.dateFrom) {
      dateFrom = reverseDate(inputs.dateFrom)
    } else {
      dateFrom = 'Inception'
    }
    let dateTo
    if (inputs.dateTo) {
      dateTo = reverseDate(inputs.dateTo)
    } else {
      dateTo = 'Present'
    }

    results.columnHeadings.push('')
    console.log(results)

    const resultRows = ResultsGrid(results, 0, results.columnHeadings.length-1, location, null, null, null, null, results.columnHeadings.length-1)
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('TKCal/calendarActivityReport/calendar_activity_report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered className="custom-table">
          <thead>
            <tr>
              <th colSpan={results.columnHeadings.length+2} className="custom-table-header">
                Activity Report
                <span><br /></span>
                <span style={{fontWeight:'normal'}}>Report executed on {date}</span>
                <span><br /></span>
                <span style={{fontWeight:'normal'}}>Report includes activity from: {dateFrom} &nbsp; to: {dateTo}</span>
              </th>
            </tr>
          </thead >
          <tbody>
            <ColumnHeadings results={results} inputs={getInputParams(location)} sortColumnClicked={sortColumnClicked} location={location} navigate={navigate} setResults={setResults} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}